import React from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Storage.css";
import { usePlacesWidget } from "react-google-autocomplete";
const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
const AddMoving = ({
  header,
  withKindOfMoving,
  handleExtraFieldChange,
  values,
  handleOnPlaceSelected,
}) => {
  const destinaion = withKindOfMoving ? "from" : "to";

  const handlePopUp = (e) => {
    if (
      (e.target.name === "fromunusualwalkway" ||
        e.target.name === "tounusualwalkway") &&
      e.target.value === "לא"
    ) {
      alert(
        "שביל כניסה חריג פירושו מרחק מהמשאית לכניסה העולה על 20 מטר או קיומם של מדרגות לפני הכניסה בבניין"
      );
    }
    if (
      (e.target.name === "fromunusualwalkway" ||
        e.target.name === "tounusualwalkway") &&
      e.target.value === "כן"
    ) {
      alert(
        `מעל 20 מטר ועד 50 מטר או עד 15 מדרגות לפני הכניסה לבניין: 25% תוספת על מחיר ההובלה\nמעל 50 מטר ועד 100 מטר ועד 30 מדרגות לפני הכניסה לבניין: 50% תוספת על מחיר ההובלה\nמעל 100 מטר ועד 150 מטר ו-30 מדרגות ומעלה לפני הכניסה לבניין: 75% תוספת על מחיר ההובלה\nעם שליחת ההזמנה נציג יחזור אליכם בהקדם האפשרי עם הצעת מחיר!`
      );
    }
    if (
      (e.target.name === "fromneedforleverage" ||
        e.target.name === "toneedforleverage") &&
      e.target.value === "כן"
    ) {
      alert(
        "מנוף מטרתו הכנסת תכולה לדירה, שבה בעיית נגישות. מחיר מנוף עד קומה 6 הינו 400-450 ₪ ומתייחס לשעת עבודה אחת בצד אחד (בכתובת המוצא או היעד). עלות המנוף אינה כלולה במחיר, ותשולם ישירות למנופאי. תיאום הגעת המנוף יתבצע על ידי חברת ההובלה."
      );
    }
    handleExtraFieldChange(e);
  };

  const { ref: fromRef } = usePlacesWidget({
    apiKey: GOOGLE_API_KEY,
    onPlaceSelected: (place, inputRefFrom) =>
      handleOnPlaceSelected(place, inputRefFrom, header),
    options: {
      types: ["address"],
      componentRestrictions: { country: "il" },
    },
  });

  const { ref: toRef } = usePlacesWidget({
    apiKey: GOOGLE_API_KEY,
    onPlaceSelected: (place, inputRefTo) =>
      handleOnPlaceSelected(place, inputRefTo, header),
    options: {
      types: ["address"],
      componentRestrictions: { country: "il" },
    },
  });

  return (
    <>
      <div>
        <h3 className="subTitle">{header}</h3>
        {withKindOfMoving ? (
          <Row className="mb-3 row">
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label className="fw-semibold mb-2">סוג הובלה</Form.Label>
              <Form.Select
                // style={{ marginRight: "12px", width: "32.2vw" }}
                name={`${destinaion}appartment`}
                value={values?.extraFields?.[`${destinaion}appartment`] ?? ""}
                onChange={handleExtraFieldChange}
              >
                <option value="1">דירת חדר</option>
                <option value="2">2 חדרים</option>
                <option value="3">3 חדרים</option>
                <option value="4">4 חדרים</option>
                <option value="5">5 חדרים</option>
                <option value="6">6 חדרים</option>
                <option value="7">7 חדרים</option>
                <option value="penthouse">פנטהאוז</option>
                <option value="private home">בית פרטי</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                נא לבחור סוג הובלה
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
        ) : (
          ""
        )}
        {header == "מהיכן?" ? (
          <Row className="mb-3 row">
            <Form.Group as={Col} className="mb-3" controlId="formBasicFrom">
              <Form.Label className="fw-semibold mb-2">כתובת</Form.Label>
              <Form.Control
                type="text"
                placeholder="ישוב מוצא"
                name={`${destinaion}address`}
                value={values?.extraFields?.[`${destinaion}address`] ?? ""}
                required
                onChange={handleExtraFieldChange}
                ref={fromRef}
              />
              <Form.Control.Feedback type="invalid">
                נא להכניס ישוב מוצא
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
        ) : (
          <Row className="mb-3 row">
            <Form.Group as={Col} className="mb-3" controlId="formBasicFrom">
              <Form.Label className="fw-semibold mb-2">כתובת</Form.Label>
              <Form.Control
                type="text"
                placeholder="ישוב יעד"
                name={`${destinaion}address`}
                value={values?.extraFields?.[`${destinaion}address`] ?? ""}
                onChange={handleExtraFieldChange}
                required
                ref={toRef}
              />

              <Form.Control.Feedback type="invalid">
                נא להכניס ישוב מוצא
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
        )}

        <Row className="mb-3 row">
          <Form.Group as={Col} className="mb-3" controlId="formBasicName">
            <Form.Label className="fw-semibold mb-2">קומה</Form.Label>
            <Form.Select
              name={`${destinaion}floor`}
              value={values?.extraFields?.[`${destinaion}floor`] ?? "בחר קומה"}
              onChange={handleExtraFieldChange}
              required
            >
              <option value="">בחר קומה</option>
              <option value="-4">-4</option>
              <option value="-3">-3</option>
              <option value="-2">-2</option>
              <option value="-1">-1</option>
              <option value="0">קרקע</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>
              <option value="18">18</option>
              <option value="19">19</option>
              <option value="20">20</option>
              <option value="21">21</option>
              <option value="22">22</option>
              <option value="23+">23+</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              נא לבחור קומה
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} className="mb-3" controlId="formBasicName">
            <Form.Label className="fw-semibold mb-2">מעלית</Form.Label>
            <Form.Select
              name={`${destinaion}transporttype`}
              value={values?.extraFields?.[`${destinaion}transporttype`] ?? "0"}
              onChange={handleExtraFieldChange}
            >
              <option value="אין">אין</option>
              <option value="4 נוסעים">4 נוסעים</option>
              <option value="6 נוסעים"> 6 נוסעים</option>
              <option value="8 נוסעים"> 8 נוסעים</option>
              <option value="משא גדולה"> משא גדולה</option>
            </Form.Select>
          </Form.Group>
        </Row>

        <Row className="mb-3 row">
          <Form.Group as={Col} className="mb-3" controlId="formBasicName">
            <Form.Label className="fw-semibold mb-2">
              שביל כניסה חריג
            </Form.Label>
            <Form.Select
              name={`${destinaion}unusualwalkway`}
              value={
                values?.extraFields?.[`${destinaion}unusualwalkway`] ??
                "האם יש?"
              }
              onChange={(e) => handlePopUp(e)}
              required
            >
              <option value="">האם יש?</option>
              <option value="לא">לא</option>
              <option value="כן">כן</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              נא לציין האם יש שביל גישה חריג
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} className="mb-3" controlId="formBasicName">
            <Form.Label className="fw-semibold mb-2">צורך במנוף</Form.Label>
            <Form.Select
              name={`${destinaion}needforleverage`}
              value={
                values?.extraFields?.[`${destinaion}needforleverage`] ?? "לא"
              }
              onChange={(e) => handlePopUp(e)}
              required
            >
              <option value="לא">לא</option>
              <option value="כן">כן</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              נא לציין האם יש צורך במנוף
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        {values?.extraFields &&
        values?.extraFields[`${destinaion}unusualwalkway`] === "כן" ? (
          <Row className="mb-3 row">
            <Form.Group className="mb-3 text" controlId="formBasicList">
              <Form.Label className="fw-semibold mb-2">
                נא פרט את השביל כניסה חריג:
              </Form.Label>
              <Form.Control
                as="textarea"
                placeholder="פרט כאן..."
                name={`${destinaion}unusualwalkwaydetails`}
                onChange={handleExtraFieldChange}
              />
            </Form.Group>
          </Row>
        ) : null}
      </div>
    </>
  );
};

export default AddMoving;
